import axios from 'axios';
import { has, get } from 'lodash';
import { constants, gql, createBlobFromResponse } from '@skunexus/utils';

const {
    CONFIG: { API_PATH },
} = constants;

export function fetchDictionaries() {
    return axios.post(`${API_PATH}/query`, {
        query: `query V1Queries {
            warehouse {
                grid(sort: {name: ASC}, filter: { status: { operator: eq, value: 1 }}, limit: { size: 9999, page:0 }){
                    rows{
                        label,
                        value: id
                    }
                }
            }
      }`,
    });
}

export const importProducts = ({ file }) => {
    const formData = new FormData();
    formData.append('csv', file);

    return axios.post(`${API_PATH}/products/import`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const getGridQueryPart = ({ apiConfig, payload }) => {
    const gridQueryConfig = get(apiConfig, 'gridConfig', apiConfig);
    const gridQueryPyload = get(payload, 'gridPayload', payload);
    const { gridField } = gridQueryConfig;

    return gql.getGridQueryPart({
        config: gridQueryConfig,
        gridField,
        payload: {
            ...gridQueryPyload,
        },
    });
};

export function exportData({ payload, apiConfig, requestConfig }) {
    const isDetailsGridExport = has(payload, 'detailsPayload');
    const gridQueryPart = getGridQueryPart({ apiConfig, payload });

    const gqlAction = isDetailsGridExport ? gql.getGraphQLDetails : gql.getGraphQLGrid;
    const gqlProps = isDetailsGridExport
        ? {
              config: {
                  ...get(apiConfig, 'detailsConfig', apiConfig),
              },
              fields: gridQueryPart,
              payload: get(payload, 'detailsPayload', payload),
          }
        : {
              config: {
                  ...get(apiConfig, 'gridConfig', apiConfig),
              },
              gridQueryPart,
          };

    return gqlAction({
        url: `${API_PATH}/query/export`,
        requestConfig: {
            headers: {
                accept: 'text/csv',
            },
            ...requestConfig,
        },
        ...gqlProps,
        config: {
            rootType: 'V1Queries @reportMode',
            ...get(gqlProps, 'config', {}),
        },
    });
}

export function repushProducts({ productsIds }) {
    return axios.post(`${API_PATH}/products/integration-many-repush`, {
        product_ids: productsIds,
    });
}
